import React, { createContext, useContext, useState } from "react";

const AdminGeneralContext = createContext({});

export const AdminGeneralContextProvider = ({ children }) => {
  // Module data will not be populated here but from the hook,
  // so that the relevant data is only loaded if necessary
  const [moduleData, setModuleData] = useState({
    crops: null,
    fertilizer: null,
    tillage_seeding: null,
  });

  return (
    <AdminGeneralContext.Provider
      value={{
        moduleData,
        setModuleData,
      }}
    >
      {children}
    </AdminGeneralContext.Provider>
  );
};

export const useAdminGeneralContext = () => useContext(AdminGeneralContext);
